import { useBrandedResource } from './useBrandedResource';
import { ResourceName } from 'config/resources/resourceNames';

export const useBrandReports = () => useBrandedResource(ResourceName.REPORTS);
